import { useState } from 'react'

import { Box, Colors } from '@factorialco/deprecated-design-system'
import {
  PerformanceEngagementSignalTableItemFragment,
  PerformanceEngagementSignalsSignalTypeEnum,
} from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { EngagementSignalTag } from 'modules/performance_analytics/components/EngagementSignalTag'

const SIGNAL_TYPE_TO_COLOR: Record<PerformanceEngagementSignalsSignalTypeEnum, Colors> = {
  positive: 'viridian800',
  neutralorpositive: 'champagne800',
  neutral: 'champagne800',
  neutralornegative: 'champagne800',
  negative: 'radicalRed800',
}
const SIGNALS_TYPE_ORDER = Object.keys(SIGNAL_TYPE_TO_COLOR)

interface Props {
  engagementSignals: PerformanceEngagementSignalTableItemFragment[]
}

export function EngagementSignalsCell({ engagementSignals }: Props) {
  const [popoverOpen, setPopoverOpen] = useState(false)

  if (engagementSignals.length === 0) {
    return null
  }

  const orderedSignals = orderBy(
    engagementSignals,
    (signal) => SIGNALS_TYPE_ORDER.indexOf(signal.type),
    'asc'
  )

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s8"
      width="s360"
      onMouseEnter={() => setPopoverOpen(true)}
      onMouseLeave={() => setPopoverOpen(false)}
    >
      <PopoverMenu type="dialog" open={popoverOpen}>
        <PopoverMenu.Trigger
          aria-label={i18n.t('performance_process.analytics.engagement_signals.show_all')}
        >
          <Box flexDirection="row" gap="s8">
            {orderedSignals.map((engagementSignal) => (
              <Box
                key={engagementSignal.name}
                width="s8"
                height="s32"
                background={SIGNAL_TYPE_TO_COLOR[engagementSignal.type]}
                borderRadius={{ all: 'abs004' }}
              />
            ))}
          </Box>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <Box paddingX="s16" alignItems="flexStart" gap="s8">
            {orderedSignals.map((signal) => (
              <EngagementSignalTag key={signal.name} engagementSignal={signal} />
            ))}
          </Box>
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
